import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { Link } from 'gatsby';
import React from 'react';
import { linkResolver } from '../../utils/linkResolver';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';

export const HeaderPayfitLogo = ({ menu, locale, className }: any) => {
  return (
    <>
      {menu?.darkLogo?.[0]?.normal?.url && (
        <div className="flex items-center md:space-x-24 xl:space-x-56">
          <ButtonTracking
            component={Link}
            section="header_logo"
            className={classNames('h-32 flex-shrink-0 md:h-36', className)}
            to={linkResolver({ slug: 'home' }, locale)}
            labelTracking="payfit logo"
          >
            <img
              src={menu?.darkLogo?.[0]?.normal?.url}
              alt={'payfit logo'}
              className="h-full"
              height={36}
              width={117}
            />
          </ButtonTracking>
        </div>
      )}
    </>
  );
};
